import { subscriptionsAdapter } from "./slice";

import type { RootState } from "../store";

const getState = (state: RootState) => state.subscriptions;
export const { selectAll, selectById } =
  subscriptionsAdapter.getSelectors(getState);
